import { SystemMessageType } from '@agent/agent-interface/contact-view/chat/model/system-message-type';

export class ChatSystemMessage {
  public type: SystemMessageType | undefined;
  public customerId: string | undefined;
  public csrId: string;
  public csrNickname: string;
  public firstName: string;
  public lastName: string;
  public content: string | undefined;
  public token: string | undefined;
  public date: number;
  public stats: any;
  public consent: boolean | undefined;
  public contactId: string | undefined;

  constructor(
    type: SystemMessageType | undefined,
    customerId: string | undefined,
    csrId: string,
    csrNickname: string,
    firstName: string,
    lastName: string,
    content: string | undefined,
    token: string | undefined,
    date: number | undefined = 0,
    stats: any | undefined = undefined,
    consent: boolean | undefined = undefined,
    contactId: string | undefined
  ) {
    this.customerId = customerId;
    this.csrId = csrId;
    this.csrNickname = csrNickname;
    this.firstName = firstName;
    this.lastName = lastName;
    this.content = content;
    this.token = token;
    this.type = type;
    this.date = date || Date.now();
    this.stats = stats;
    this.consent = consent;
    this.contactId = contactId;
  }

  public static fromWebSocket(o: any) {
    return new ChatSystemMessage(
      o.type,
      o.customerId,
      o.csrId,
      o.csrNickname,
      o.firstName,
      o.lastName,
      o.content,
      o.token,
      o.date,
      o.stats,
      o.consent,
      o.contactId
    );
  }

  public isFromCustomer(): boolean {
    return this.csrId === null || this.csrId === undefined;
  }
}
